module.exports = __webpack_public_path__ + "static/media/reuters-black.29ef9e9b.png";